// extracted by mini-css-extract-plugin
export default {"item_container":"burger-ingredient-item_item_container__iJtIR","image":"burger-ingredient-item_image__xO59t"};